export default __webpack_public_path__ + "images/cd0ae1c9df610488b024718cca5a5887.svg";